import { TONE_CLASSES } from "../assets/assetUtils";

export const HSE_STATUS_TONE = { draft: TONE_CLASSES.soon, approved: TONE_CLASSES.ok, archived: TONE_CLASSES.none };
export const HSE_STATUS_LABEL = { draft: "Draft", approved: "Approved", archived: "Archived" };

export const fmtDate = (iso) => (iso ? new Date(iso.length === 10 ? `${iso}T00:00:00` : iso).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "—");

/** Plain-text section → simple HTML-ish render: "Heading:" lines, "- " bullets, "1. " steps, paragraphs. */
export function SectionText({ text, className = "" }) {
  const lines = (text || "").split("\n");
  const out = [];
  let para = [];
  let bullets = [];
  const flushPara = () => { if (para.length) { out.push(<p key={`p${out.length}`} className="text-sm leading-relaxed mb-2">{para.join(" ")}</p>); para = []; } };
  const flushBullets = () => { if (bullets.length) { out.push(<ul key={`u${out.length}`} className="list-disc pl-5 mb-2 space-y-0.5">{bullets.map((b, i) => <li key={i} className="text-sm leading-relaxed">{b}</li>)}</ul>); bullets = []; } };
  lines.forEach((raw) => {
    const line = raw.trim();
    if (!line) { flushPara(); flushBullets(); return; }
    if (/^[-*•]\s+/.test(line)) { flushPara(); bullets.push(line.replace(/^[-*•]\s+/, "")); return; }
    flushBullets();
    if (/^\d+[.)]\s+/.test(line)) { flushPara(); out.push(<p key={`n${out.length}`} className="text-sm leading-relaxed pl-5 -indent-5 mb-0.5">{line}</p>); return; }
    if (line.endsWith(":") && line.length <= 90) { flushPara(); out.push(<p key={`h${out.length}`} className="text-sm font-semibold mt-3 mb-1">{line.slice(0, -1)}</p>); return; }
    para.push(line);
  });
  flushPara(); flushBullets();
  return <div className={className}>{out.length ? out : <p className="text-sm text-muted-foreground">—</p>}</div>;
}

export function SectionTable({ rows = [], columns = [] }) {
  if (!rows.length) return <p className="text-sm text-muted-foreground">—</p>;
  return (
    <div className="overflow-x-auto rounded-md border border-border">
      <table className="w-full text-xs">
        <thead className="bg-muted/60"><tr>{columns.map((c) => <th key={c} className="text-left px-2 py-1.5 font-semibold capitalize">{c.replace(/_/g, " ")}</th>)}</tr></thead>
        <tbody>{rows.map((r, i) => <tr key={i} className="border-t border-border align-top">{columns.map((c) => <td key={c} className="px-2 py-1.5">{r[c]}</td>)}</tr>)}</tbody>
      </table>
    </div>
  );
}
